var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters } from 'vuex';
import { MENU_ITEMS } from '@/stores/defs';
import { isEmpty, filter } from 'lodash';
var itemMixin = {
    computed: __assign({}, mapGetters({
        getItemWithId: MENU_ITEMS.GET_ITEM,
        getItemWithParentId: MENU_ITEMS.GET_BY_PARENT_ASSET_ID,
    })),
    methods: {
        _displayName: function (item) {
            var quantity = item.quantity;
            var name = item.name;
            var multiple = (quantity > 1) ? quantity + "x " : '';
            var masterOption = item.masterOption;
            if (!masterOption) {
                return "" + multiple + name;
            }
            var masterChoice = masterOption.choices[0];
            return "" + multiple + masterChoice.name + " " + name;
        },
        _masterOption: function (item) {
            var requiredOptions = this._requiredOptions(item);
            if (isEmpty(requiredOptions)) {
                return null;
            }
            return requiredOptions[0];
        },
        _requiredOptions: function (item) {
            var options = item.options;
            return filter(options, function (option) {
                return (!!option.required);
            });
        },
        _nonMasterOptions: function (item) {
            var masterOption = this._masterOption(item);
            var options = item.options;
            if (!masterOption) {
                return options;
            }
            return filter(options, function (option) {
                return option.id !== masterOption.id;
            });
        },
    }
};
export default itemMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/itemMixin.ts
// module id = co8o
// module chunks = 18